export enum SCREEN_QUERY {
    SMALL = '(max-width: 399px)',
    MEDIUM = '(min-width: 400px) and (max-width: 1399px)',
    LARGE = '(min-width: 1400px)',
}
